<template>
	<div>
		<ContainerTitle icon="desktop" title="Administração"/>
		<div class="usuarios pt-0 pb-3 ">
			<ListarUsuarioFiltro @filter="filter" />
			<UsuarioList :rows="result.list" @refresh="refresh"/>
			<ModalAlert id="usuarios-list-vazio">
					<DynamicIcon icon="exclamation" :classString="'alert-exclamation'"/>
					Não existe beneficiários para o(s) filtro(s) selecionado(s).
				</ModalAlert>

			<PaginationTable :page="page" :totalPages="result.totalPages" :totalItens="result.totalItens" @changePage="changePage" />
		</div>
	</div>
</template>

<script>
import ListarUsuarioFiltro from "./components/ListarUsuarioFiltro";
import UsuarioList from "./components/UsuarioList"
import PaginationTable from "@/components/commons/table/components/PaginationTable.vue";
import ModalAlert from "../../../../commons/ModalAlert.vue"
import ContainerTitle from "@/components/commons/ContainerTitle.vue";
import UserResource from "@/resources/UserResource"

export default {
	nome: "Listar Usuarios",
	components: { 
		ListarUsuarioFiltro,
		UsuarioList,
		PaginationTable,
		ContainerTitle,
		ModalAlert
	},
	data() {
		return {
			result: {
				list: [],
				totalPages: 0,
				totalItens: 0
			},
			page: 1,
			filterForm: {}
		};
	},
	methods: {
		isDisabled( disabled ){			
			return !disabled ?  "Ativo" : "Desabilitado"
		},
		filter( event ) {
			this.page = 1
			this.filterForm = event

			this.loadList( )							
		},
		loadList( ) {
			UserResource.filter( this.filterForm , this.page , {context: "userFilter", showLoader: true})
			.then(( result ) => {
				this.result = result
			})
		},
		refresh( ) {
			this.loadList()			
		},
		changePage( page ){
			this.page = page
			this.loadList( )	
		}
	},
	created(){
		this.loadList()
	}
}
</script>

<style scoped>
.div-listing-users {
	overflow-x: auto;
	margin-top: 25px;
	border-radius: 10px;
	background-color: #fff;
}

.title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 60px;
	padding: 0px 20px;
	font-size: 16px;
	font-weight: 600;
	letter-spacing: 2.1px;
	color: #FF612B;
}

.listing-users-notable {
	text-align: initial;
	padding: 20px;
	color: #707070;
	font-size: 18px;
}

.listing-users {
	background-color: #fff;
	border-radius: 10px;
	overflow: hidden;
	width: 100%;
	padding: 3px;
}

.listing-users-indicators {
	color: #efefee !important;
	background-color: #bbbec0;
	font-size: 14px !important;
	letter-spacing: 2px !important;
}

.listing-users tr {
	height: 45px;
	text-align: initial;
}

.listing-users tr th,
.listing-users tr td {
	padding: 0px 10px;
}

.itens-tabela-usuarios:nth-child(odd) {
	background-color: #efefee;
	border-left: 1px solid #fff;
	border-right: 2px solid #fff;
}

.listing-users:last-child {
	border-bottom: 5px solid #fff;
}

.tr-status {
	display: flex;
	align-items: center;
	height: 45px;
}

.status {
	margin: 0px;
	padding: 3px 10px;
	border-radius: 20px;
	font-size: 12px;
	font-weight: 600;
	color: #fff;
}

.Ativo {
	background-color: #007000;;
}

.Desabilitado {
	background-color: #d13f44;
}

.listing-user-table-item-btns{
	text-align: end;
}

.listing-user-table-item-btns button {
	width: 39px;
	height: 39px;
	border-radius: 20px !important;
	font-size: 20px !important;
}

.listing-user-table-item-btns button:nth-child(2) {
	margin: 0px 10px;
}

.listing-user-table-item-btns button {
	border: 1px solid #FF612B !important;
	background-color: #FF612B;
	color: #fff;
	padding: 0;
}

.listing-user-table-item-btns button:hover {
	border: 1px solid #FF612B !important;
	background-color: #fff;
	color: #FF612B;
}

.listing-user-table-item-btns button:last-child {
	border: 1px solid #FF612B !important;
	background-color: #fff;
	color: #FF612B;
}

.listing-user-table-item-btns button:last-child:hover {
	border: 1px solid #FF612B !important;
	background-color: #FF612B;
	color: #fff;
}

.listing-user-table-item-btns button:first-child .listing-user-table-item-icon {
	width: 0.85em !important;
}

.icon-pagination{
	font-size: 1.5em;
}

.icon-pagination:hover{
	transform: scale(1.25);
	color: #FF612B;
	cursor: pointer;
}

.item-pagination-disabled{
	color: gray
}

.item-pagination-disabled:hover{
	transform: none;
	color: gray;
	cursor: initial;
}

.pagination-usuarios {
	padding: 8px 20px 3px 10px;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.pagination-usuarios div:nth-child(1){
	font-size: 1.4em;
	font-weight: 600;
	letter-spacing: 2.1px;
	color: #FF612B;
}
.pagination-usuarios .icon-pagination:nth-child(3){
	margin-left: 10px;
}

@media (max-width: 620px) {
	.listing-users {
		border-radius: 0px;
		min-width: 900px;
	}

	.title > .btn-base {
		padding: 2px;
	}

}
</style>